import BoardEntity from "..//controllers/boards/entity";
import Utils from "../utils/index";
import UtilsUser from "../utils/user";

export default class Header {
    constructor() {
        (document.querySelectorAll(".ticket_queue_favorite") as NodeListOf<HTMLElement>).forEach((elem: any) => {
            elem.addEventListener("click", async (e: any) => {
                e.preventDefault()
                const uuid = elem.getAttribute("data-id") as string
                if (elem.classList.contains("ti-star")) {
                    //new fav
                    await UtilsUser.addTicketQueueFavorite(uuid)
                    elem.classList.remove("ti-star")
                    elem.classList.add("ti-star-filled")
                } else {
                    await UtilsUser.removeTicketQueueFavorite(uuid)
                    elem.classList.remove("ti-star-filled")
                    elem.classList.add("ti-star")
                }

            })
        });
        (document.querySelectorAll(".nav_add_link") as NodeListOf<HTMLElement>).forEach((elem: any) => {
            elem.addEventListener("click", async (e: any) => {
                e.preventDefault()
                const url = elem.getAttribute("href")
                document.location.href = url;
            })
        });

        if(document.querySelector("#newTicketBoardModal")) {
            (document.querySelector("#newTicketBoardForm") as HTMLFormElement).addEventListener("submit", async (e) => {
                e.preventDefault();
                const form = (document.querySelector("#newTicketBoardForm") as HTMLFormElement)
                const data = BoardEntity.getEntityData(form)
                await Utils.showLoader()
                const entity = await Utils.entity.upsert(data, 'tickets/boards')
                await Utils.hideLoader()
                if(entity.status === 200) {
                    const data = entity.data[0]
                    document.location.href = `/${(window as any).currentLocale}/ticket/boards/${data.id}`
                }
            })
        }
    }
}
